<template>
  <span>
    <div class="col-xs-12 col-md-4 compare-indicators" style="margin-top: 2px;">
      <div class="panel panel-primary widget" id="widget_">
        <div class="panel-heading">
          <div class="row compare-panel-switch">
            <div @click="expandedBool()" class="col-xs-2 comparison-options">
              <span style>EXPAND</span>
              <v-icon>zoom_out_map</v-icon>
            </div>

            <div
              @click="changeComponent('zones')"
              class="col-xs-offset-2 col-xs-2 comparison-options"
               ref="zonalBotton"
            >
              <span style>ZONES MAP</span>
              <img id="map-icon" src="static/img/icons/map-icon.svg" alt="" srcset="" >
              <!-- <i class="fas fa icon fas fa-map-marker"></i> -->
            </div>

            <div
              @click="changeComponent('states')"
              class="col-xs-2 comparison-options compare-option-selected"
              ref="stateBotton"
            >
              <span style>STATES MAP </span>
             <img id="map-icon" src="static/img/icons/map-icon.svg" alt="" srcset="" >
              <!-- <i class="fas fa icon fas fa-map-marker"></i> -->
            </div>

            <div @click="changeComponent('line')" class="col-xs-2 comparison-options"
            ref="lineBotton">
              <span style>LINE CHART</span>
              <v-icon>show_chart</v-icon>
            </div>

            <div @click="changeComponent('column')" class="col-xs-2 comparison-options">
              <span style>COLUMN CHART</span>
              <v-icon>bar_chart</v-icon>
            </div>
          </div>
        </div>
        <div class="row panel-body">
          <!-- Map type here -->
          <span v-show="componentType==='Map'">
            <div class="custom-row ms-compare-container">
              <div class="col-xs-12 year-multiselect compare-multiselect">
                <multi-select
                  v-model="selectedIndicator"
                  :options="indicatorAndProgramAreas"
                  group-values="indicators"
                  group-label="programArea"
                  :group-select="false"
                  :group-collapsible-expanded="false"
                  @open="openedIndicatorMultiselect"
                  @close="closedIndicatorMultiselect"
                  :placeholder="indicatorPlaceholder"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult">Oops! No indicator found. Change the search query.</span>
                </multi-select>
              </div>
              <div class="col-xs-7 year-multiselect compare-multiselect">
                <multi-select
                  v-model="source"
                  :options="compareSecSources"
                  :allow-empty="false"
                  :AllowEmpty="false"
                  :show-labels="false"
                  :placeholder="sourcePlaceholder"
                  @open="openedcompareSecSourcesMultiselect"
                  @close="closedcompareSecSourcesMultiselect"
                >
                  <span slot="noResult">Oops! No source found. Change the search query.</span>
                </multi-select>
              </div>
              <div class="col-xs-5 year-multiselect compare-multiselect">
                <multi-select
                  v-model="year"
                  :options="yearOptions"
                  :disable="!yearOptions.length"
                  :allow-empty="false"
                  :AllowEmpty="false"
                  :show-labels="false"
                  :placeholder="yearPlaceholder"
                  @open="openedYearOptionMultiselect"
                  @close="closedYearOptionMultiselect"
                ></multi-select>
              </div>
            </div>
            <div>
              <!-- StateMap -->
              <div class="row" v-show="specificMapType==='states'">
                <div class="col-sm-12">
                  <div v-if="noStateData" class="chart-has-no-data">
                    <img src="static/img/no_data.svg" style />
                  </div>
                  <div v-else class="chart-wrapper">
                    <div class="chart-stage">
                      <highmaps :options="stateOptions" ref="highmaps"></highmaps>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End -->

              <!-- RegionsMap -->
              <div class="row" v-show="specificMapType==='zones'">
                <div class="col-sm-12" style="overflow: hidden;">
                  <div v-if="noZoneData" class="chart-has-no-data">
                    <img src="static/img/no_data.svg" style />
                  </div>
                  <div v-else class="chart-wrapper">
                    <div class="chart-stage">
                      <highmaps :options="zoneOptions" ref="highmaps"></highmaps>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End -->
            </div>

            <b-modal :active.sync="expandedView" has-modal-card>
              <form action>
                <div class="modal-card">
                  <header class="modal-card-head" style="padding: 0;">
                    <div class="custom-row ms-compare-container">
                      <div class="col-xs-6 year-multiselect compare-multiselect">
                        <multi-select
                          v-model="selectedIndicator"
                          :options="indicatorAndProgramAreas"
                          group-values="indicators"
                          group-label="programArea"
                          :group-select="false"
                          :group-collapsible-expanded="false"
                          @open="openedIndicatorMultiselect"
                          @close="closedIndicatorMultiselect"
                          :placeholder="indicatorPlaceholder"
                          :allow-empty="false"
                          :show-labels="false"
                        >
                          <span slot="noResult">Oops! No indicator found. Change the search query.</span>
                        </multi-select>
                      </div>
                      <div class="col-xs-3 year-multiselect compare-multiselect">
                        <multi-select
                          v-model="source"
                          :options="compareSecSources"
                          :allow-empty="false"
                          :group-select="false"
                          :hide-selected="false"
                          :placeholder="sourcePlaceholder"
                          :show-labels="false"
                          @open="openedcompareSecSourcesMultiselect"
                          @close="closedcompareSecSourcesMultiselect"
                        >
                          <span slot="noResult">Oops! No source found. Change the search query.</span>
                        </multi-select>
                      </div>
                      <div class="col-xs-3 year-multiselect compare-multiselect">
                        <multi-select
                          v-model="year"
                          :options="yearOptions"
                          :disable="!yearOptions.length"
                          :allow-empty="false"
                          :placeholder="yearPlaceholder"
                          :hide-selected="false"
                          :show-labels="false"
                          @open="openedYearOptionMultiselect"
                          @close="closedYearOptionMultiselect"
                        ></multi-select>
                      </div>
                    </div>
                  </header>
                  <section>
                    <!-- StateMap -->
                    <div class="row" v-show="specificMapType==='states'">
                      <div class="col-sm-12">
                        <div v-if="noStateData" class="chart-has-no-data">
                          <img src="static/img/no_data.svg" style />
                        </div>
                        <div v-else class="chart-wrapper">
                          <div class="chart-stage">
                            <highmaps :options="stateOptions" ref="highmaps"></highmaps>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End -->

                    <!-- RegionsMap -->
                    <div class="row" v-show="specificMapType==='zones'">
                      <div class="col-sm-12" style="overflow: hidden;">
                        <div v-if="noZoneData" class="chart-has-no-data">
                          <img src="static/img/no_data.svg" style />
                        </div>
                        <div v-else class="chart-wrapper">
                          <div class="chart-stage">
                            <highmaps :options="zoneOptions" ref="highmaps"></highmaps>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End -->
                  </section>
                  <footer class="modal-card-foot">
                    <button
                      class="button is-danger pull-right"
                      type="button"
                      @click="closeExpandedBool"
                    >CLOSE</button>
                  </footer>
                </div>
              </form>
            </b-modal>
          </span>
          <!-- Map type end -->

          <!-- Chart type Here -->
          <span v-show="componentType === 'Charts'">
            <div class="custom-row ms-compare-container">
              <div class="col-xs-8 col-md-12 year-multiselect compare-multiselect">
                <multi-select
                  v-model="selectedIndicator"
                  :options="indicatorAndProgramAreas"
                  group-values="indicators"
                  group-label="programArea"
                  :group-select="false"
                  :group-collapsible-expanded="false"
                  @open="openedIndicatorMultiselect"
                  @close="closedIndicatorMultiselect"
                  :placeholder="indicatorPlaceholder"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult">Oops! No indicator found. Change the search query.</span>
                </multi-select>
              </div>
              <div class="col-xs-4 col-md-12 year-multiselect compare-multiselect">
                <multi-select
                  v-model="source"
                  :options="compareSecSources"
                  :allow-empty="false"
                  :AllowEmpty="false"
                  :show-labels="false"
                  :placeholder="sourcePlaceholder"
                  @open="openedcompareSecSourcesMultiselect"
                  @close="closedcompareSecSourcesMultiselect"
                >
                  <span slot="noResult">Oops! No source found. Change the search query.</span>
                </multi-select>
              </div>
            </div>
            <div class="col-xs-12">
              <!-- LineChart here -->
              <div class="row">
                <div v-if="!chartData.length" class="chart-has-no-data">
                  <img src="static/img/no_data.svg" style />
                </div>
                <div v-else class="chart-wrapper">
                  <div class="chart-stage">
                    <highcharts :options="highchart_options" ref="highcharts"></highcharts>
                  </div>
                </div>
              </div>
              <!-- End -->
            </div>

            <b-modal :active.sync="expandedView" has-modal-card>
              <form action>
                <div class="modal-card">
                  <header class="modal-card-head" style="padding: 0;">
                    <div class="custom-row ms-compare-container">
                      <div class="col-xs-8 year-multiselect compare-multiselect">
                        <multi-select
                          v-model="selectedIndicator"
                          :options="indicatorAndProgramAreas"
                          group-values="indicators"
                          group-label="programArea"
                          :group-select="false"
                          :group-collapsible-expanded="false"
                          @open="openedIndicatorMultiselect"
                          @close="closedIndicatorMultiselect"
                          :placeholder="indicatorPlaceholder"
                          :allow-empty="false"
                          :show-labels="false"
                        >
                          <span slot="noResult">Oops! No indicator found. Change the search query.</span>
                        </multi-select>
                      </div>
                      <div class="col-xs-4 year-multiselect compare-multiselect">
                        <multi-select
                          v-model="source"
                          :options="compareSecSources"
                          :allow-empty="false"
                          :placeholder="sourcePlaceholder"
                          @open="openedcompareSecSourcesMultiselect"
                          @close="closedcompareSecSourcesMultiselect"
                          :group-select="false"
                          :hide-selected="false"
                          :show-labels="false"
                        >
                          <span slot="noResult">Oops! No source found. Change the search query.</span>
                        </multi-select>
                      </div>
                    </div>
                    <p class="modal-card-title"></p>
                  </header>
                  <section>
                    <!-- LineChart here -->
                    <div class="row">
                      <div v-if="!chartData.length" class="chart-has-no-data">
                        <img src="static/img/no_data.svg" style />
                      </div>
                      <div v-else class="chart-wrapper">
                        <div class="chart-stage">
                          <highcharts :options="highchart_options" ref="highcharts"></highcharts>
                        </div>
                      </div>
                    </div>
                    <!-- End -->
                  </section>
                  <footer class="modal-card-foot">
                    <button
                      class="button is-danger pull-right"
                      type="button"
                      @click="closeExpandedBool"
                    >CLOSE</button>
                  </footer>
                </div>
              </form>
            </b-modal>
          </span>
          <!-- Chart End -->
        </div>
      </div>
    </div>
  </span>
</template>
<script src="../public/js/jquery3.1.1.min.js"></script>
<script src="../node_modules/bootstrap/dist/js/bootstrap.min.js"></script>


<script>
import zone_map_data from "@/assets/js-on/nigmap_region_data";
import state_map_data from "@/assets/js-on/nigeria_map_data";
import MultiSelect from "@/assets/js-on/vue-multiselect";
import { mapGetters, mapState, mapActions } from "vuex";
// import LineChart from './chartTypes/charts'

export default {
  name: "CompareSection",
  components: {
    MultiSelect
    // LineChart
  },
  props: ["relatedIndicator"],
  data() {
    var data = [
      ["ng-ne", 0],
      ["ng-nw", 1],
      ["ng-nc", 2],
      ["ng-se", 3],
      ["ng-sw", 4],
      ["ng-ss", 5]
    ];
    var state_data = [
      ["ng-ri", 0],
      ["ng-kt", 1],
      ["ng-so", 2],
      ["ng-za", 3],
      ["ng-yo", 4],
      ["ng-ke", 5],
      ["ng-ad", 6],
      ["ng-bo", 7],
      ["ng-ak", 8],
      ["ng-ab", 9],
      ["ng-im", 10],
      ["ng-by", 11],
      ["ng-be", 12],
      ["ng-cr", 13],
      ["ng-ta", 14],
      ["ng-kw", 15],
      ["ng-la", 16],
      ["ng-ni", 17],
      ["ng-fc", 18],
      ["ng-og", 19],
      ["ng-on", 20],
      ["ng-ek", 21],
      ["ng-os", 22],
      ["ng-oy", 23],
      ["ng-an", 24],
      ["ng-ba", 25],
      ["ng-go", 26],
      ["ng-de", 27],
      ["ng-ed", 28],
      ["ng-en", 29],
      ["ng-eb", 30],
      ["ng-kd", 31],
      ["ng-ko", 32],
      ["ng-pl", 33],
      ["ng-na", 34],
      ["ng-ji", 35],
      ["ng-kn", 36]
    ];
    return {
      states: [
        "National",
        "Abia",
        "Adamawa",
        "Akwa Ibom",
        "Anambra",
        "Bauchi",
        "Bayelsa",
        "Benue",
        "Borno",
        "Cross River",
        "Delta",
        "Ebonyi",
        "Edo",
        "Ekiti",
        "Enugu",
        "FCT",
        "Gombe",
        "Imo",
        "Jigawa",
        "Kaduna",
        "Kano",
        "Katsina",
        "Kebbi",
        "Kogi",
        "Kwara",
        "Lagos",
        "Nasarawa",
        "Niger",
        "Ogun",
        "Ondo",
        "Osun",
        "Oyo",
        "Plateau",
        "Rivers",
        "Sokoto",
        "Taraba",
        "Yobe",
        "Zamfara"
      ],
      stateToShortCode: {
        Abia: "ng-ab",
        Adamawa: "ng-ad",
        "Akwa Ibom": "ng-ak",
        Anambra: "ng-an",
        Bauchi: "ng-ba",
        Benue: "ng-be",
        Borno: "ng-bo",
        Bauchi: "ng-ba",
        Bayelsa: "ng-by",
        "Cross River": "ng-cr",
        Delta: "ng-de",
        Ebonyi: "ng-eb",
        Edo: "ng-ed",
        Ekiti: "ng-ek",
        Enugu: "ng-en",
        FCT: "ng-fc",
        Gombe: "ng-go",
        Imo: "ng-im",
        Jigawa: "ng-ji",
        Kano: "ng-kn",
        Katsina: "ng-kt",
        Kaduna: "ng-kd",
        Kebbi: "ng-ke",
        Kogi: "ng-ko",
        Kwara: "ng-kw",
        Lagos: "ng-la",
        Nasarawa: "ng-na",
        Niger: "ng-ni",
        Ogun: "ng-og",
        Ondo: "ng-on",
        Osun: "ng-os",
        Oyo: "ng-oy",
        Plateau: "ng-pl",
        Rivers: "ng-ri",
        Sokoto: "ng-so",
        Taraba: "ng-ta",
        Yobe: "ng-yo",
        Zamfara: "ng-za"
      },
      senateZones: [
        "South-East",
        "North-Central",
        "North-East",
        "North-West",
        "South-South",
        "South-West"
      ],
      lsData: JSON.parse(localStorage.getItem("car_other_dataset")),
      meta_data_dataset: JSON.parse(localStorage.getItem("meta_data_dataset")),
      indicatorIndex: null,
      percentage: null,
      noStateData: false,
      noZoneData: false,
      zonesData: {},
      statesData: {},
      chartData: [],
      yearOptions: [],
      sources: [],
      compareSecSources: [],
      state: "National",
      year: null,
      source: null,
      selectedIndicator: "ANC Coverage (4 visits)",
      yearPlaceholder: null,
      sourcePlaceholder: null,
      indicatorPlaceholder: "ANC Coverage (4 visits)",
      indicatorMultiselectOpened: false,
      optionYearMultiselectOpened: false,
      sourcesMultiselectOpened: false,
      relatedIndicatorOne: null,
      relatedIndicatorTwo: null,
      specificComponentType: "Map",
      componentType: "Map",
      specificMapType: "states",
      specificChartType: "line",
      expandedView: false,
      expandedBoolVal: false,



      colors: [
        "#2f7ed8",
        "#0d233a",
        "#8bbc21",
        "#910000",
        "#1aadce",
        "#492970",
        "#f28f43",
        "#77a1e5",
        "#c42525",
        "#a6c96a"
      ],
      zoneToShortCode: {
        "North-East": "ng-ne",
        "North-West": "ng-nw",
        "North-Central": "ng-nc",
        "South-East": "ng-se",
        "South-West": "ng-sw",
        "South-South": "ng-ss"
      },
      highchart_options: {
        chart: {
          type: "line",
          height: 440,
          zoomType: "xy"
        },
        title: {
          text: "Loading...",
          style: {
            fontSize: "16px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600"
          }
        },

        subtitle: {
          text: "Loading...",
          style: {
            fontSize: "11px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "normal"
          }
        },
        credits: {
          enabled: false
        },
        xAxis: {
          type: "category",
          categories: null,
          title: {
            enabled: false,
            text: "x-axis title"
          },
          labels: {
            style: {
              fontWeight: "normal",
              color: "#686464"
            }
          },
          tickInterval: 4,
          showLastLabel: true
        },
        yAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          min: 0,
          title: {
            text: ""
          }
        },
        legend: {
          enabled: true,
          verticalAlign: "top",
          x: -20,
          y: -5,
          title: {},
          itemStyle: {
            fontWeight: "normal",
            fontSize: "13px"
          }
        },
        plotOptions: {
          series: {
            connectNulls: true,
            borderWidth: 0,
            dataLabels: {
              enabled: false,
              format: "{point.y:.1f}%",
              style: {
                fontWeight: "normal"
              }
            },
            cursor: "pointer",
            dashStyle: "Solid",
            point: {},
            marker: {
              lineWidth: 0,
              radius: 3,
              symbol: "circle"
            },
            connectNulls: true
          },
          colorByPoint: true
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:11px"><b>{series.name}</b></span><br>',
          pointFormat: "<span><b>{point.x}: {point.y:.2f}</b></span><br/>"
        },
        series: [
          {
            name: "example",
            data: []
          }
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "printChart",
                "separator",
                "downloadPNG",
                "downloadJPEG",
                "downloadPDF",
                "downloadSVG",
                "separator",
                "downloadCSV",
                "downloadXLS",
                "openInCloud"
              ],
              symbol: "download"
            }
          }
        }
      },
      zoneOptions: {
        chart: {
          map: "countries/ng/ng-all",
          borderColor: "#335cad",
          height: 438
        },

        colors: [
          "#2f7ed8",
          "#0d233a",
          "#8bbc21",
          "#910000",
          "#1aadce",
          "#492970",
          "#f28f43",
          "#77a1e5",
          "#c42525",
          "#a6c96a"
        ],

        credits: {
          enabled: true,
          text: "Map of Nigeria"
        },

        title: {
          text: "Loading...",
          style: {
            fontSize: "16px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600"
          }
        },

        subtitle: {
          text: "Loading...",
          style: {
            fontSize: "11px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "normal"
          }
        },

        exporting: {
          csv: {
            dateFormat: "%Y-%m-%d"
          }
        },

        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "middle",
            align: "right"
          }
        },

        legend: {
          enabled: true,
          layout: "horizontal",
          align: "right"
        },

        colorAxis: {
          // min: 0,
          // max: 100,
          minColor: "#E6E7E8",
          maxColor: "#114663"
        },

        plotOptions: {
          map: {
            allAreas: false,
            mapData: zone_map_data, // Highcharts.maps['countries/ng/ng-all'],
            states: {
              hover: {
                color: "#BADA55"
              }
            },
            joinBy: "hc-key",
            dataLabels: {
              allowOverlap: true,
              align: "center",
              crop: true,
              style: {
                fontFamily: "'Open Sans', sans-serif",
                fontSize: 10
              },
              enabled: true,
              //format: '{point.name}',
              color: "#FFFFFF",
              formatter: function() {
                if (this.point.value) {
                  return this.point.name;
                }
              }
            },
            tooltip: {
              headerFormat: "<b>{series.name}</b><br>",
              pointFormat: "{point.name}: <b>{point.value:.2f}</b>"
            }
          }
        },
        series: [
          {
            type: "map",
            data: data,
            name: "Random Name"
          }
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "printChart",
                "separator",
                "downloadPNG",
                "downloadJPEG",
                "downloadPDF",
                "downloadSVG",
                "separator",
                "downloadCSV",
                "downloadXLS",
                //"viewData",
                "openInCloud"
              ],
              symbol: "download"
              // symbolStrokeWidth: 2,
              // symbolFill: '#330033',
              // symbolStroke: '#b3d4fc'
            }
          }
        }
      },
      stateOptions: {
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500
              },
              chartOptions: {
                height: 550
              }
            }
          ]
        },
        chart: {
          map: "countries/ng/ng-all",
          borderColor: "#335cad",
          style: {
            fontFamily: "'Open Sans', sans-serif",
            fontSize: "12px"
          },
          height: 438
        },

        colors: [
          "#2f7ed8",
          "#0d233a",
          "#8bbc21",
          "#910000",
          "#1aadce",
          "#492970",
          "#f28f43",
          "#77a1e5",
          "#c42525",
          "#a6c96a"
        ],

        credits: {
          enabled: true,
          text: "Map of Nigeria"
        },

        title: {
          text: "Loading...",
          style: {
            fontSize: "16px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600"
          }
        },

        subtitle: {
          text: "Loading...",
          style: {
            fontSize: "11px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "normal"
          }
        },

        exporting: {
          csv: {
            dateFormat: "%Y-%m-%d"
          }
        },

        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "middle",
            align: "right"
          }
        },
        legend: {
          enabled: true,
          layout: "vertical",
          align: "right"
        },
        colorAxis: {
          minColor: "#E6E7E8",
          maxColor: "#114663"
        },

        plotOptions: {
          map: {
            allAreas: false,
            mapData: state_map_data,
            states: {
              hover: {
                color: "#BADA55"
              }
            },
            joinBy: "hc-key",
            dataLabels: {
              enabled: true,
              color: "#FFFFFF",
              formatter: function() {
                if (this.point.value) {
                  return this.point.name;
                }
              }
            },
            tooltip: {
              headerFormat: "<b>{series.name}</b><br>",
              pointFormat: "{point.name}: <b>{point.value:.2f}</b>"
            }
          }
        },
        series: [
          {
            data: state_data,
            name: "Random Name"
          }
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "printChart",
                "separator",
                "downloadPNG",
                "downloadJPEG",
                "downloadPDF",
                "downloadSVG",
                "separator",
                "downloadCSV",
                "downloadXLS",
                //"viewData",
                "openInCloud"
              ],

              symbol: "download"
            }
          }
        }
      }
    };
  },
  computed: {
    programAreas() {
      let meta_data = this.meta_data_dataset.slice(0);
      let programAreas = [];
      meta_data.forEach((datas, index) => {
        if (index > 0) {
          //We are getting the program area located at index 6 of the array
          programAreas.push(datas[6]);
        }
      });
      const distinct = (value, index, array) => {
        return array.indexOf(value) === index;
      };
      let distinctProgramAreas = programAreas.filter(distinct);
      return distinctProgramAreas;
    },

    indicatorAndProgramAreas() {
      let indicatorAndProgramArea = [];
      this.programAreas.map(area => {
        let tempIndicators = [];
        this.meta_data_dataset.slice(0).filter((datas, index) => {
          if (datas[6] === area) {
            tempIndicators.push(datas[0]);
          }
        });

        let obj = {
          programArea: area,
          indicators: tempIndicators
        };
        indicatorAndProgramArea.push(obj);
      });
      return indicatorAndProgramArea;
    },

    relatedIndicators() {
      let allRelatedIndicators = null;
      let relatedIndicators = [];
      let self = this;

      this.indicatorAndProgramAreas.forEach(datas => {
        datas.indicators.filter(data => {
          if (data === self.selectedIndicator) {
            allRelatedIndicators = datas.indicators;
          }
        });
      });
      allRelatedIndicators = allRelatedIndicators.filter(
        indicator => indicator !== self.selectedIndicator
      );
      return allRelatedIndicators;
    },

    indicatorAndSourceIndex() {
      var indicatorAndSource = `${this.selectedIndicator} -> ${this.source}`;
      var indicatorIndex = this.lsData[0].indexOf(indicatorAndSource);
      return indicatorIndex;
    },

    selectedState() {
      return this.$store.state.CAR.selectedState;
    }
  },
  methods: {
    loadData() {
      var self = this;
      this.yearOptions = [];
      this.compareSecSources = [];
      let statesWithData = [];
      // this.states = []

      // Trying to locate the column that the data exists in the localstorage and getting the sources for the indicator
      this.lsData.forEach((datas, index) => {
        if (index === 0) {
          datas.filter(data => {
            // checking for the selected indicator matches
            var isMatched = data.includes(self.selectedIndicator);
            if (isMatched) {
              // Getting the index position of the -> character to the beginning index of the source name
              var position = data.indexOf("->") + 3;
              var spliceData = data.slice(position);
              self.compareSecSources.push(spliceData);
            }
          });
        }
      });

      /**
       * If the sources available don't have NDHS, use the 1st index or else use the index of NDHS
       */
      if (this.compareSecSources.indexOf("MICS") < 0) {
        this.source = this.compareSecSources[0];
        this.sourcePlaceholder = this.compareSecSources[0];
      } else {
        this.source = this.compareSecSources[
          this.compareSecSources.indexOf("MICS")
        ];
        this.sourcePlaceholder = this.compareSecSources[
          this.compareSecSources.indexOf("MICS")
        ];
      }

      var indicatorAndSource = `${this.selectedIndicator} -> ${this.source}`;

      // This is where we get the indicatorAndSource index position
      this.indicatorIndex = this.lsData[0].indexOf(indicatorAndSource);

      // This is where we get the years options
      this.lsData.forEach((datas, indexOne) => {
        datas.forEach((data, indexTwo) => {
          if (
            indexTwo === self.indicatorIndex &&
            datas[self.indicatorIndex] !== "" &&
            indexOne !== 0
          ) {
            self.yearOptions.push(datas[0].toString());
            // With the below option we are getting the states that have data for that indicator and source
            statesWithData.push(datas[1]);
            // self.states.push(datas[1])
          }
        });
      });

      // Get distinct years
      const distinct = (value, index, array) => {
        return array.indexOf(value) === index;
      };
      this.yearOptions = this.yearOptions.filter(distinct).sort();
      statesWithData = statesWithData.filter(distinct);
      // this.states = this.states.filter(distinct)

      this.yearOptions.sort(function(a, b){
        return b - a;
      })

      // Here we the yearPlaceholder is being set to the value of the last index
      this.yearPlaceholder = this.yearOptions[0];
      this.year = this.yearOptions[0];

      this.getAllStatesAndZonesData(
        this.selectedIndicator,
        this.source,
        this.year
      );
      this.getStateYearsData(this.selectedState);
    },

    resetIndicatorData(
      newIndicator = this.selectedIndicator,
      source = this.source,
      state = this.selectedState
    ) {
      var self = this;
      this.yearOptions = [];
      this.compareSecSources = [];

      // Trying to locate the column that the data exists in the localstorage
      this.lsData.forEach((datas, index) => {
        if (index === 0) {
          datas.filter(data => {
            // checking for the selected indicator matches
            var isMatched = data.includes(newIndicator);
            if (isMatched) {
              // Getting the index position of the -> character to the beginning index of the source name
              var position = data.indexOf("->") + 3;
              var spliceData = data.slice(position);
              self.compareSecSources.push(spliceData);
            }
          });
        }
      });

      if (this.compareSecSources.indexOf(source) > -1) {
        this.source = source;
        this.sourcePlaceholder = source;
      } else {
        this.source = this.compareSecSources[0];
        this.sourcePlaceholder = this.compareSecSources[0];
      }

      // this.source = this.compareSecSources[0]
      // this.sourcePlaceholder = this.compareSecSources[0]
      var indicatorAndSource = `${newIndicator} -> ${this.source}`;

      // This is where we get the indicatorsAndSource index position
      this.indicatorIndex = this.lsData[0].indexOf(indicatorAndSource);

      // This is where we get the years options
      this.lsData.forEach((datas, indexOne) => {
        datas.forEach((data, indexTwo) => {
          if (
            indexTwo === self.indicatorIndex &&
            datas[self.indicatorIndex] !== "" &&
            indexOne !== 0
          ) {
            self.yearOptions.push(datas[0].toString());
            // With the below option we are getting the states that have data for that indicator and source
          }
        });
      });

      // This functions return distinct years
      const distinct = (value, index, array) => {
        return array.indexOf(value) === index;
      };
      this.yearOptions = this.yearOptions.filter(distinct);

      this.yearOptions.sort(function(a, b){
        return b - a;
      })

      // Here we the yearPlaceholder and year properties are being set to the value of the lastitem in the array
      this.yearPlaceholder = this.yearOptions[0];
      this.year = this.yearOptions[0];

      this.getAllStatesAndZonesData(newIndicator, this.source, this.year);
      this.getStateYearsData(this.selectedState);

    },

    resetSourceData(source = this.source) {
      var indicatorAndSource = `${this.selectedIndicator} -> ${source}`;
      var self = this;
      this.yearOptions = [];

      this.indicatorIndex = this.lsData[0].indexOf(indicatorAndSource);

      // This is where we get the years options
      this.lsData.forEach((datas, indexOne) => {
        datas.forEach((data, indexTwo) => {
          if (
            indexTwo === self.indicatorIndex &&
            datas[self.indicatorIndex] !== "" &&
            indexOne !== 0
          ) {
            self.yearOptions.push(datas[0].toString());
          }
        });
      });

      // This functions return distinct years
      const distinct = (value, index, array) => {
        return array.indexOf(value) === index;
      };
      this.yearOptions = this.yearOptions.filter(distinct);

      this.yearOptions.sort(function(a, b){
        return b - a;
      })

      // Here we the yearPlaceholder and year properties are being set to the value of the lastitem in the array
      this.yearPlaceholder = this.yearOptions[0];
      this.year = this.yearOptions[0];

      this.getAllStatesAndZonesData(this.selectedIndicator, source, this.year);
      this.getStateYearsData(this.selectedState);
    },

    updateCompareSecSources(newIndicator = this.selectedIndicator) {
      this.compareSecSources = [];

      let self = this;
      this.lsData.forEach((datas, index) => {
        if (index === 0) {
          datas.filter(data => {
            // checking for the selected indicator matches
            var isMatched = data.includes(newIndicator);
            if (isMatched) {
              // Getting the index position of the -> character to the beginning index of the source name
              var position = data.indexOf("->") + 3;
              var spliceData = data.slice(position);
              self.compareSecSources.push(spliceData);
            }
          });
        }
      });
    },

    getAllStatesAndZonesData(
      indicator = this.selectedIndicator,
      source = this.source,
      year = this.year
    ) {
      // reset datas
      this.allData = [];
      var self = this;

      var indicatorAndSource = `${indicator} -> ${source}`;

      // This is where we get the indicatorAndSource index position
      this.indicatorIndex = this.lsData[0].indexOf(indicatorAndSource);

      this.lsData.map(datas => {
        // Here we are getting data by year and the index of the selected Source & Indicator,
        // only picking non empty values and would not include National data
        if (
          datas[0] === parseInt(year) &&
          datas[self.indicatorIndex] !== "" &&
          datas[1] !== "National"
        ) {
          self.allData.push({
            state: datas[1],
            value: parseFloat(datas[self.indicatorIndex].toFixed(2))
          });
        }
      });

      this.plotZoneMap(indicator, source, year, this.allData);
      this.plotStateMap(indicator, source, year, this.allData);
      //switches to line chart if there is no data in zonal and state
      // console.log(self.allData);
      this.automaticSwitchFunction(self.allData);

    },

    /*The function automatically switches to line chart when there is no data
    for both of the maps(state and zonal).
    and switch to zonal maps when there is available data on zonal
    and no data for state maps
    */
    automaticSwitchFunction(data){
      // the if statement checks the current position on the component
       if(this.specificMapType == 'zones' || this.specificMapType == 'states'){
        if(data.length < 6){
           this.$refs.stateBotton.click();
         }
         if(data.length == 6){   // if data length is 6. it means only zonal data is available
          // so switch to zonal maps
           this.$refs.zonalBotton.click();
         }
         if(data.length == 0){ //if there is no data in array switch to line chart
            this.$refs.lineBotton.click();
            this.$refs.lineBotton.classList.add('compare-option-selected');
            this.$refs.stateBotton.classList.remove('compare-option-selected');

         }
       }
    },

    getStateYearsData(state = this.selectedState) {
      this.chartData = [];

      // get stateYears data
      var self = this;
      this.lsData.map(datas => {
        if (datas[1] === state && datas[self.indicatorAndSourceIndex] !== "" && datas[self.indicatorAndSourceIndex] !== undefined) {
          this.chartData.push([
            datas[0],
            parseFloat(datas[self.indicatorAndSourceIndex].toFixed(2))
          ]);
        }
      });
      this.plotChart(this.chartData);
    },

    plotChart(data) {
      this.highchart_options.title.type = this.specificChartType;
      this.highchart_options.title.text = this.selectedIndicator;
      this.highchart_options.subtitle.text = `${this.source} - ${this.selectedState}`;
      this.highchart_options.series[0].name = this.source;
      this.highchart_options.series[0].data = data;

      let color = this.colors[Math.floor(Math.random() * 10)];
      this.highchart_options.series[0].color = color;
      this.highchart_options.exporting.filename = `${this.specificChartType} (${this.source})`;
      this.highchart_options.plotOptions.series.maxPointWidth = 8;

      if (data.length < 8) {
        this.highchart_options.xAxis.tickInterval = 1;
      } else if (data.length < 16) {
        this.highchart_options.xAxis.tickInterval = 2;
      } else if (data.length < 24) {
        this.highchart_options.xAxis.tickInterval = 4;
      } else {
        this.highchart_options.xAxis.tickInterval = 8;
      }
    },

    plotZoneMap(indicator, source, year, allData) {
      /**
       * Separate zones data
       */
      this.zonesData = {};
      let zoneData = [];
      let self = this;
      this.senateZones.filter(zone => {
        self.zonesData[zone] = {};
        allData.forEach(datas => {
          if (datas.state === zone && datas.value !== "") {
            zoneData.push(datas.value);
            self.zonesData[zone] = datas.value;
          }
        });
      });

      /**
       * Checking if there is zone data returns true or false
       */
      this.noZoneData = zoneData.length ? false : true;

      /**
       * Setting options for Map
       */
      this.zoneOptions.title.text = indicator;
      this.zoneOptions.exporting.filename =
        indicator + " (" + source + " - " + year + ")";
      this.zoneOptions.subtitle.text = source + " - " + year;
      this.zoneOptions.series[0].name = source;
      this.zoneOptions.series[0].data = Object.keys(this.zoneToShortCode).map(
        (elem, index) => {
          return [self.zoneToShortCode[elem], self.zonesData[elem]];
        }
      );
    },

    plotStateMap(indicator, source, year, allData) {
      /**
       * Separate states data excluding National data
       */
      this.statesData = {};
      let stateData = [];
      let self = this;
      this.states.filter(state => {
        if (state !== "National") {
          this.statesData[state] = {};
          allData.forEach(datas => {
            if (datas.state === state) {
              stateData.push(datas.value);
              this.statesData[state] = datas.value;
            }
          });
        }
      });

      /**
       * Checking if there is state data returns true or false
       */
      this.noStateData = stateData.length ? false : true;

      /**
       * Setting options for Map
       */
      this.stateOptions.title.text = indicator;
      this.stateOptions.subtitle.text = source + " - " + year;
      this.stateOptions.exporting.filename =
        indicator + " (" + source + " - " + year + ")";
      this.stateOptions.series[0].name = source;
      this.stateOptions.legend = {
        enabled: true,
        layout: "horizontal",
        align: "right"
      };
      this.stateOptions.series[0].data = Object.keys(this.stateToShortCode).map(
        (elem, index) => {
          return [self.stateToShortCode[elem], self.statesData[elem]];
        }
      );
    },

    getRelatedIndicators() {
      let start = 0;
      let end = this.relatedIndicators.length - 1;

      // This function return a range btw 0 and the length of the relatedIndicators array
      function range(start, end) {
        var ans = [];
        for (let i = start; i <= end; i++) {
          ans.push(i);
        }
        return ans;
      }
      let val = range(start, end); // return an array of ranges form 0 to the length of the relatedIndicators array

      let relatedIndexOne = Math.floor(Math.random() * end);
      let relatedIndexTwo = Math.floor(Math.random() * end);

      // Checks if the 2nd random number is equal to the 1st
      // then it increases or decreases the 2nd random number
      if (relatedIndexOne === relatedIndexTwo) {
        if (relatedIndexTwo <= end) {
          relatedIndexTwo++;
        } else {
          relatedIndexTwo--;
        }
      }

      this.relatedIndicatorOne = this.relatedIndicators[relatedIndexOne];
      this.relatedIndicatorTwo = this.relatedIndicators[relatedIndexTwo];
    },

    compareSectionClicked() {
      //Event listener to change background color of clicked div
      let sections = document.querySelectorAll(".comparison-options");
      if (sections.length > 0) {
        let section1 = [],
          section2 = [],
          section3 = [];
        for (var i in sections) {
          if (i < 5) {
            section1.push(sections[i]);
          } else if (i > 4 && i < 10) {
            section2.push(sections[i]);
          } else if (i > 9 && i < sections.length) {
            section3.push(sections[i]);
          }
        }
        sections.forEach((section, index) => {
          section.addEventListener("click", () => {
            if (index < 5) {
              section1.forEach(el => {
                if (el.className.indexOf(" compare-option-selected") > 0) {
                  el.className = el.className.replace(
                    " compare-option-selected",
                    ""
                  );
                }
              });
            } else if (index > 4 && index < 10) {
              section2.forEach(el => {
                if (el.className.indexOf(" compare-option-selected") > 0) {
                  el.className = el.className.replace(
                    " compare-option-selected",
                    ""
                  );
                }
              });
            } else if (index > 9 && index < sections.length) {
              section3.forEach(el => {
                if (el.className.indexOf(" compare-option-selected") > 0) {
                  el.className = el.className.replace(
                    " compare-option-selected",
                    ""
                  );
                }
              });
            }
            section.className += " compare-option-selected";
          });
        });
      }
    },

    openedIndicatorMultiselect() {
      this.indicatorPlaceholder = "Search indicator";
    },
    closedIndicatorMultiselect() {
      this.indicatorPlaceholder = this.selectedIndicator;
    },
    openedYearOptionMultiselect() {
      this.optionYearMultiselectOpened = true;
      this.yearPlaceholder = "Choose a year";
    },
    closedYearOptionMultiselect() {
      this.optionYearMultiselectOpened = false;
      var index = this.yearOptions.indexOf(this.year);
      this.yearPlaceholder = this.yearOptions[index];
    },
    openedcompareSecSourcesMultiselect() {
      this.sourcesMultiselectOpened = true;
      this.sourcePlaceholder = "Choose a Source";
    },
    closedcompareSecSourcesMultiselect() {
      this.sourcesMultiselectOpened = false;
      this.sourcePlaceholder = this.source;
    },
    changeComponent(type) {
      this.specificComponentType = type;
      if (type === "zones" || type === "states") {
        this.componentType = "Map";
        this.specificMapType = type;
      } else {
        this.componentType = "Charts";
        this.specificChartType = type;
      }
    },

    expandedBool() {
      this.expandedBoolVal = true;
      this.expandedView = true;
    },

    closeExpandedBool(val) {
      this.expandedBoolVal = false;
      this.expandedView = false;
    }
  },
  mounted() {
    this.selectedIndicator = this.relatedIndicator;
    this.indicatorPlaceholder = this.relatedIndicator;

    this.loadData();
    this.updateCompareSecSources();
  },
  updated() {
    this.compareSectionClicked();
  },
  watch: {
    year(newYearOption, old) {
      this.getAllStatesAndZonesData(
        this.selectedIndicator,
        this.source,
        newYearOption
      );
    },
    selectedIndicator(newIndicator, oldIndicator) {
      this.resetIndicatorData(newIndicator, this.source, this.selectedState);
      this.yearPlaceholder = !this.yearOptions.length
        ? "No Year Data"
        : this.year.toString();
      this.getStateYearsData(this.selectedState);
    },
    source(newSource, oldSource) {
      this.resetSourceData(newSource);
      this.getStateYearsData(this.selectedState);
      // this.yearPlaceholder = !this.yearOptions.length ? 'No Year Data': this.year.toString()
    },
    state(newState, oldState) {
      this.getStateYearsData(newState);
      // this.yearPlaceholder = !this.yearOptions.length ? 'No Year Data': this.yearOptions[0].toString()
    },
    selectedState(newState, oldState) {
      this.getStateYearsData(newState);
      // this.yearPlaceholder = !this.yearOptions.length ? 'No Year Data': this.yearOptions[0].toString()
    },
    relatedIndicator(newIndicator, old) {
      this.selectedIndicator = newIndicator;
      this.indicatorPlaceholder = newIndicator;
      this.relatedIndicator = newIndicator;
      this.resetIndicatorData(newIndicator, this.source, this.selectedState);
      this.getStateYearsData(this.selectedState);
    },
    chartData(val, old) {
      this.plotChart(val);
    },
    specificChartType(val, old) {
      this.highchart_options.chart.type = val;
    }
  }
};
</script>
<style>
  .svg-inline--fa.fa-w-12 {
    width: .40em !important;
}
.application--light .icon {
    /* color: inherit !important; */
    margin-left: 5px;
}
#map-icon {
    margin-left: 5px;
    width:1.6em !important;
}
</style>



// WEBPACK FOOTER //
// CompareSec.vue?17fea9ea